import { Component } from '@angular/core';

import { environment } from '@env/environment';
import { build } from '../../../build';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
})
export class FooterComponent {
    readonly currentYear: number = new Date().getFullYear();
    readonly showTag: boolean = !!environment.build.tag;
    readonly showTime: boolean = !!environment.build.time;
    readonly tag: string = build.tag;
    readonly time: string = build.time;
}
